const state = {
  searchQuery: ''
};

const mutations = {
  setSearchQuery(state, query) {
    state.searchQuery = query;
  },
  resetSearch(state) {
    state.searchQuery = ''; 
  }
};

const actions = {
  updateSearchQuery({ commit }, query) {
    //console.log('query', query);
    commit('setSearchQuery', query);
  },
  resetSearch({ commit }) {
    commit('resetSearch');
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};